import type { Tables, Json } from "@/integrations/supabase/types";

export type Path = Tables<"path">;
export type PathActivity = Tables<"path_activity">;

export interface PathFormData {
  title: string;
  pathType: string;
  themeId: string | null;
  metadata: Record<string, unknown> | null;
  resources: Record<string, unknown> | null;
}

export interface EditorPathActivity {
  localId: string;
  activityId: string;
  activityTitle: string;
  activityVersion: number;
  activityDurationMinutes: number | null;
  orderIndex: number;
  existingId?: string;
}

export const PATH_TYPES = [
  { value: "path", label: "Parcours" },
  { value: "onboarding", label: "Onboarding" },
  { value: "meteo", label: "Météo mentale" },
] as const;
